import styled from 'styled-components';

const NewJobListWrapper = styled.div`
  padding: 1em 1em 2.5em;
  max-width: 1600px;
  margin: 0 auto;
  .filters {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &> div {
      width: 23.5%;
    }
  }
`;


export default {
  NewJobListWrapper
};
